import { ElMessage } from 'element-plus'
// 去旧IM：群操作改走自研后端（custom.js 里这些接口已指向 Go），不再 import 旧IM SDK
import {
    getOtherGroupInfo,
    getDict,
    addHxUserName,
    removeHxUserName,
    updateAnnouncement,
    updateGroupSettings,
    getGroupAnnouncement,
    listGroupAdmins
} from '@/api/custom'

function normalizeGroupMembers(data) {
    const list = Array.isArray(data) ? data : Object.values(data || {})
    return list
        .map((item) => {
            const hx = item.hxid || item.hxusername || item.member
            if (!hx) return null
            return {
                ...item,
                hxid: hx,
                hxusername: hx,
                member: hx,
                username: item.username || item.nickName || item.userName || hx,
                avartarurl: item.avartarurl || item.avatarurl || item.avatar || '',
                avatarurl: item.avatarurl || item.avartarurl || item.avatar || '',
                type: item.type || 'member'
            }
        })
        .filter(Boolean)
}

function membersToPersonMap(list) {
    const obj = {}
    list.forEach((item) => {
        obj[item.hxid] = item
    })
    return obj
}

const Groups = {
    state: {
        groupsInfos: {},
        currentGroupPersons: {},
        userTypes: {}
    },
    mutations: {
        SET_GORUPS_ADMINS: (state, payload) => {
            const { groupId, admin } = payload
            if (state.groupsInfos[groupId]) {
                state.groupsInfos[groupId].admin = admin
            } else {
                state.groupsInfos[groupId] = {}
                state.groupsInfos[groupId].admin = admin
            }
        },
        SET_GOUPS_MEMBERS: (state, payload) => {
            const { groupId, members } = payload
            if (state.groupsInfos[groupId]) {
                state.groupsInfos[groupId].members = members
            } else {
                state.groupsInfos[groupId] = {}
                state.groupsInfos[groupId].members = members
            }
        },
        SET_GROUPS_BLIACK_LIST: (state, payload) => {
            const { groupId, blacklist } = payload
            if (state.groupsInfos[groupId]) {
                state.groupsInfos[groupId].blacklist = blacklist
            } else {
                state.groupsInfos[groupId] = {}
                state.groupsInfos[groupId].blacklist = blacklist
            }
        },
        SET_GOUPS_MUTE_LIST: (state, payload) => {
            const { groupId, mutelist } = payload
            if (state.groupsInfos[groupId]) {
                state.groupsInfos[groupId].mutelist = mutelist
            } else {
                state.groupsInfos[groupId] = {}
                state.groupsInfos[groupId].mutelist = mutelist
            }
        },
        SET_GOUPS_ANNOUN: (state, payload) => {
            const { groupId, announcement } = payload
            if (state.groupsInfos[groupId]) {
                state.groupsInfos[groupId].announcement = announcement
            } else {
                state.groupsInfos[groupId] = {}
                state.groupsInfos[groupId].announcement = announcement
            }
        },
        SET_CURRENT_GROUP_PERSONS: (state, payload) => {
            state.currentGroupPersons = payload
        },
        SET_USER_TYPES: (state, payload) => {
            state.userTypes = payload
        }
    },
    actions: {
        // 获取所有用户类型（字典，走后端）
        getAllUserTypes: async ({ commit }) => {
            const { data } = await getDict('IMGroupMembersType')
            if (data && data.length) {
                let obj = {}
                for (let i = 0; i < data.length; i++) {
                    obj[data[i].dictValue] = { ...data[i] }
                }
                commit('SET_USER_TYPES', obj)
            }
        },
        // 初始群信息：成员/管理员/公告 均走自研 Go 后端；黑名单/禁言业务本无，不拉
        fetchMultiGoupsInfos: async ({ dispatch }, groupid) => {
            dispatch('fetchGoupsMember', groupid)
            dispatch('fetchGoupsAdmin', groupid)
            dispatch('fetchAnnounment', groupid)
        },
        // 群管理员/群主 → 自研 Go 后端 listGroupAdmins
        fetchGoupsAdmin: async ({ commit }, params) => {
            try {
                const { data } = await listGroupAdmins(params)
                commit('SET_GORUPS_ADMINS', { groupId: params, admin: data || [] })
            } catch (e) {
                commit('SET_GORUPS_ADMINS', { groupId: params, admin: [] })
            }
        },
        // 自定义获取群成员（走后端 getOtherGroupInfo，含成员角色）
        getGroupPersons: async ({ commit }, params) => {
            try {
                let { data } = await getOtherGroupInfo(params.groupId, params.fromHxId)
                commit('SET_CURRENT_GROUP_PERSONS', membersToPersonMap(normalizeGroupMembers(data)))
            } catch (e) {
                console.error('[去旧IM] 拉群成员失败', e)
                commit('SET_CURRENT_GROUP_PERSONS', {})
            }
        },
        // 群成员：同样走后端 getOtherGroupInfo
        fetchGoupsMember: async ({ commit }, params) => {
            try {
                const { data } = await getOtherGroupInfo(params, '')
                commit('SET_GOUPS_MEMBERS', { groupId: params, members: normalizeGroupMembers(data) })
            } catch (e) {
                commit('SET_GOUPS_MEMBERS', { groupId: params, members: [] })
            }
        },
        // 群公告 → 自研 Go 后端 getGroupAnnouncement
        fetchAnnounment: async ({ commit }, params) => {
            try {
                const { data } = await getGroupAnnouncement(params)
                commit('SET_GOUPS_ANNOUN', { groupId: params, announcement: data || '' })
            } catch (e) {
                commit('SET_GOUPS_ANNOUN', { groupId: params, announcement: '' })
            }
        },
        // 群黑名单：后端暂未提供，容错置空
        fetchGoupsBlackList: async ({ commit }, params) => {
            commit('SET_GROUPS_BLIACK_LIST', { groupId: params, blacklist: [] })
        },
        // 群禁言列表：后端暂未提供，容错置空
        fetchGoupsMuteList: async ({ commit }, params) => {
            commit('SET_GOUPS_MUTE_LIST', { groupId: params, mutelist: [] })
        },
        // 修改群名/群详情 → 后端 updateGroupSettings
        modifyGroupInfo: async ({ commit }, params) => {
            const { groupid, modifyType, content } = params
            const data = { groupId: groupid }
            if (modifyType === 0) data.groupName = content
            else data.groupDesc = content
            try {
                await updateGroupSettings(data)
                if (modifyType === 0) {
                    commit('UPDATE_GROUP_INFOS', { groupId: groupid, type: 'groupName', params: content })
                    commit('UPDATE_GROUP_LIST', { type: 'updateGroupName', groupId: groupid, groupName: content })
                } else {
                    commit('UPDATE_GROUP_INFOS', { groupId: groupid, type: 'groupDescription', params: content })
                }
                ElMessage({ message: '修改成功~', type: 'success' })
            } catch (e) {
                ElMessage({ message: '修改失败，请稍后重试~', type: 'error' })
            }
        },
        // 设置/修改群公告 → 后端 updateAnnouncement
        modifyGroupAnnouncement: async ({ commit }, params) => {
            try {
                await updateAnnouncement({ groupId: params.groupId, announcement: params.announcement })
                commit('SET_GOUPS_ANNOUN', { groupId: params.groupId, announcement: params.announcement })
                ElMessage({ message: '群公告已更新~', type: 'success' })
            } catch (e) {
                ElMessage({ message: '群公告更新失败~', type: 'error' })
            }
        },
        // 邀请群成员 → 后端 addHxUserName（逐个拉入）
        inviteUserJoinTheGroup: async ({ dispatch }, params) => {
            const { users, groupId } = params
            try {
                const list = Array.isArray(users) ? users : [users]
                for (const hx of list) {
                    await addHxUserName({ groupId, hxUserName: hx })
                }
                ElMessage({ message: '群组邀请成功送出~', type: 'success' })
                dispatch('getGroupPersons', { groupId, fromHxId: '' })
            } catch (error) {
                ElMessage({ message: '群组邀请失败，请稍后重试~', type: 'error' })
            }
        },
        // 移出群成员 → 后端 removeHxUserName
        removeTheGroupMember: async ({ dispatch }, params) => {
            const { username, groupId } = params
            try {
                await removeHxUserName({ groupId, hxUserName: username })
                ElMessage({ message: `已将${username}移出群组!`, type: 'success' })
                dispatch('getGroupPersons', { groupId, fromHxId: '' })
            } catch (error) {
                ElMessage({ message: '该群成员移出失败，请稍后重试！', type: 'error' })
            }
        },
        // 黑名单/禁言：自研后端暂未提供，提示暂不支持（避免点击报错）
        addMemberToBlackList: async () => {
            ElMessage({ message: '当前版本暂不支持黑名单操作', type: 'warning' })
        },
        removeTheMemberFromBlackList: async () => {
            ElMessage({ message: '当前版本暂不支持黑名单操作', type: 'warning' })
        },
        addMemberToMuteList: async () => {
            ElMessage({ message: '当前版本暂不支持禁言操作', type: 'warning' })
        },
        removeTheMemberFromMuteList: async () => {
            ElMessage({ message: '当前版本暂不支持禁言操作', type: 'warning' })
        }
    },
    getters: {}
}

export default Groups
